<flow-field
  *ngFor="let childField of fieldSet.getFieldsList(); index as i"
  [field]="childField"
  [showCurrentFieldIndicator]="false"
  (focusNextField)="focusNextChildField(i)"
>
</flow-field>
